
export default function BlogAdd() {
  return (
      <h1>BlogAdd</h1>
  );
}
